// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "-" + {"440":"df8efa55c0ab69a9d766","581":"95d60f8c6b97163a756d"}[chunkId] + ".js";
};